import { X, CheckCircle, Gift, Bell } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { commonFuncActions } from "../../../redux/slices/commonFun";
import { motion, AnimatePresence } from "framer-motion";

export default function CongratulationsPopup() {
  const showPopUp = useSelector((store) => store.commonFunc.showPopUp);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(commonFuncActions.hideCongratulationPopUp());
  };

  return (
    <AnimatePresence>
      {showPopUp && (
        <div className="fixed font-serif inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <motion.div
            initial={{ opacity: 0, y: -100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="bg-white rounded-lg shadow-xl max-w-md w-full overflow-hidden"
          >
            <div className="relative bg-gradient-to-r from-blue-500 to-purple-600 py-6">
              <div className="absolute top-2 right-2">
                <button
                  onClick={handleClose}
                  className="text-white hover:text-gray-200 transition-colors p-1"
                >
                  <X size={20} />
                </button>
              </div>
              <div className="flex justify-center">
                <div className="bg-white rounded-full p-3 mb-2">
                  <CheckCircle size={48} className="text-green-500" />
                </div>
              </div>
            </div>

            <div className="p-6 text-center">
              <h2 className="text-2xl font-serif font-bold text-gray-800 mb-2">
                Congratulations!
              </h2>
              <p className="text-gray-600 mb-6">
                You've successfully subscribed to our newsletter. Thank you for
                joining our community!
              </p>

              <div className="space-y-4 mb-6">
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-2 mr-3">
                    <Bell size={20} className="text-blue-600" />
                  </div>
                  <div className="text-left">
                    <p className="text-gray-700 font-medium">Stay Updated</p>
                    <p className="text-gray-500 text-sm">
                      Get the latest news and updates
                    </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="bg-purple-100 rounded-full p-2 mr-3">
                    <Gift size={20} className="text-purple-600" />
                  </div>
                  <div className="text-left">
                    <p className="text-gray-700 font-medium">
                      Exclusive Offers
                    </p>
                    <p className="text-gray-500 text-sm">
                      Access to special deals and promotions
                    </p>
                  </div>
                </div>
              </div>

              <button
                onClick={handleClose}
                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-medium rounded-lg text-sm px-5 py-3 text-center transition-colors"
              >
                Continue Browsing
              </button>

              <p className="text-xs text-gray-500 mt-4">
                We've sent a confirmation email. Please check your inbox.
              </p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
